export default class SelectBox {
	static init() {
		Array.prototype.forEach.call(document.querySelectorAll('.select-box'), el => {
			new SelectBox(el);
		});
	}

	isOpen = false;
	classes = {
		node: 'select-box',
		open: 'select-box--is-open',
		option: 'select-box__option',
		optionSelected: 'select-box__option--is-selected',
		optionLabel: 'select-box__option-label',
		optionsInput: 'select-box__option input'
	}

	constructor(element) {
		if (!element) return;
		this.element = element;
		this.optionsInput = this.element.querySelectorAll('.' + this.classes.optionsInput);

		// link handler
		window.addEventListener('click', (e) => {
			let target = e.target;

			if (target.dataset.type === 'form-link') {
				e.preventDefault();
				e.stopPropagation();

				if(!target.dataset.select) return;

				this.select(this.getOptionByValue(target.dataset.select));
				this.close();
			}
		});

		// open / close handler
		window.addEventListener('click', (e) => {
			const target = e.target;
			if (e.target.isSameNode(document.body)) return;
			const element = target.closest('.select-box') ? target.closest('.select-box') : false;

			if (!element || element.id !== this.element.id) {
				this.close();
			}
		});

		// select handler
		this.element.addEventListener('click', (e) => {
			const target = e.target;
			const option = target.classList.contains(this.classes.option) ? target : false;
			const selected = target.classList.contains(this.classes.optionSelected) ? target : false;

			if (selected) {
				this.open();
			}

			if (option && !selected) {
				this.select(option);
				this.close();
			}
		});
	}

	open() {
		this.isOpent = true;
		this.element.classList.toggle(this.classes.open);
	}

	close() {
		this.isOpen = false;
		this.element.classList.remove(this.classes.open);
	}

	select(option) {
		let selectedContainer = this.element.querySelector('.' + this.classes.optionSelected);
		option.querySelector('input').checked = true;
		selectedContainer.querySelector('.' + this.classes.optionLabel).innerHTML = option.querySelector('.' + this.classes.optionLabel).innerHTML;
	}

	getSelected() {
		return Array.prototype.find.call(this.optionsInput, el => el.checked);
	}

	getOptionByValue(value) {
		return Array.prototype.find.call(this.optionsInput, el => el.value === value.toString()).closest('.' + this.classes.option);
	}
}
